import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { VideoGenerationStatus } from './VideoGenerationStatus';
import { useVideoGeneration } from '../../hooks/useVideoGeneration';

interface OrderConfirmationProps {
  orderId: string;
}

export const OrderConfirmation: React.FC<OrderConfirmationProps> = ({ orderId }) => {
  const { status, error, generatedVideoUrl } = useVideoGeneration(orderId);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center"
    >
      <div className="mb-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-6">
          Order Successfully Submitted! 🎅✨
        </h3>
        
        <VideoGenerationStatus status={status} error={error} />
        
        {status === 'completed' && generatedVideoUrl && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="mt-6"
          >
            <Button
              variant="primary"
              onClick={() => window.open(generatedVideoUrl, '_blank')}
              className="w-full mb-4"
            >
              Download Your Magical Video
            </Button>
          </motion.div>
        )}
      </div>

      <div className="space-y-4">
        <Button
          variant="outline"
          onClick={() => window.location.href = '/dashboard'}
          className="w-full"
        >
          View My Videos
        </Button>
        <Button
          variant="outline"
          onClick={() => window.location.href = '/'}
          className="w-full"
        >
          Return to Home
        </Button>
      </div>
    </motion.div>
  );
};